import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Initialize the controller
  }

  formatUrl(event) {
    const input = event.target
    let value = input.value.trim()
    
    // If the field is empty, don't do anything
    if (!value) return
    
    // If it already starts with http:// or https://, don't modify
    if (value.match(/^https?:\/\//)) return
    
    // If it starts with www., add https://
    if (value.match(/^www\./)) {
      value = `https://${value}`
    }
    // If it doesn't start with www. and doesn't have a protocol, add https://www.
    else if (!value.match(/^https?:\/\//) && !value.match(/^www\./)) {
      // Check if it looks like a domain (contains a dot and doesn't have spaces)
      if (value.includes('.') && !value.includes(' ')) {
        value = `https://www.${value}`
      }
    }
    
    // Update the input value
    input.value = value
  }

  blur(event) {
    this.formatUrl(event)
  }

  // Also format on Enter key press
  keydown(event) {
    if (event.key === 'Enter') {
      this.formatUrl(event)
    }
  }
} 